<template>
  <div class="private-page" :style="backgroundStyle">
    <!-- 粒子动画容器 -->
    <div ref="particlesContainer" class="particles-container"></div>

    <!-- 统一界面 -->
    <div class="welcome-container">
      <div class="welcome-content">
        <div class="logo-section">
          <img
            src="@/assets/logo/128x128.png"
            alt="Logo"
            class="logo"
            @click="handleLogoClick"
          />
          <h1 class="welcome-title">欢迎使用XChatSpace</h1>
        </div>

        <div class="info-section">
          <p class="welcome-text">
            {{ ready ? '您可以开始畅聊了' : '正在加载...' }}
          </p>
          <div v-if="!ready" class="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div v-else class="success-icon">
            <i class="el-icon-success"></i>
          </div>
        </div>

        <div v-if="ready" class="action-section">
          <button class="enter-btn" @click="enterSystem">
            <i class="el-icon-right"></i>
            开始聊天
          </button>
          <p class="tip-text">点击开始您的聊天之旅</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInfo } from '@/api/user';
import { setToken, getToken } from '@/utils/auth';
import store from '@/store';
import Particles from './particles.js';

export default {
  name: 'PrivatePage',
  data() {
    return {
      urlParams: {},
      ready: false,
      particles: null,
      token: '',
      backgroundStyle: {
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      },
      // 快速点击相关数据
      clickCount: 0,
      clickTimer: null,
      lastClickTime: 0,
      platform: '',
    };
  },
  mounted() {
    this.readUrlParams();
    this.initParticles();
  },
  beforeDestroy() {
    // 清理粒子动画
    if (this.particles) {
      this.particles.destroy();
      this.particles = null;
    }
    // 清理定时器
    if (this.clickTimer) {
      clearTimeout(this.clickTimer);
    }
  },
  methods: {
    // 处理logo点击事件
    handleLogoClick() {
      const currentTime = Date.now();

      // 如果距离上次点击超过1秒，重置计数
      if (currentTime - this.lastClickTime > 1000) {
        this.clickCount = 0;
      }

      this.clickCount++;
      this.lastClickTime = currentTime;

      // 清除之前的定时器
      if (this.clickTimer) {
        clearTimeout(this.clickTimer);
      }

      // 设置1秒后重置计数
      this.clickTimer = setTimeout(() => {
        this.clickCount = 0;
      }, 1000);

      // 如果达到5次点击
      if (this.clickCount >= 5) {
        this.triggerSecretAction();
        this.clickCount = 0; // 重置计数
      }
    },

    // 触发秘密动作
    triggerSecretAction() {
      this.copyTokenToClipboard();
      this.$message({
        message: 'token已复制到剪贴板',
        type: 'success',
        duration: 3000,
      });
    },
    copyTokenToClipboard() {
      navigator.clipboard.writeText(this.token);
    },

    initParticles() {
      // 等待 DOM 更新后初始化粒子
      this.$nextTick(() => {
        if (this.$refs.particlesContainer) {
          this.particles = new Particles(this.$refs.particlesContainer, {
            zIndex: 1,
            opacity: 0.6,
            color: '255, 255, 255',
            count: 200,
            maxDistance: 8000,
            mouseMaxDistance: 15000,
            lineColor: 'rgba(255, 255, 255, 0.3)',
          });
        }
      });
    },
    readUrlParams() {
      // 使用Vue Router的query获取URL参数
      const params = this.$route.query;
      this.urlParams = params;
      if (params.token) {
        if (params.token.indexOf('=') > -1) {
          let token = params.token.split('=')[1];
          this.getUserInfo(token);
        } else {
          this.getUserInfo(params.token);
        }
      } else {
        Object.entries(params).forEach(([key, value]) => {
          if (key.indexOf('=') > -1) {
            let token = key.split('=')[1];
            this.getUserInfo(token);
          }
        });
      }
    },
    async getUserInfo(token) {
      this.token = token;
      setToken(token);
      getInfo().then((res) => {
        console.log('用户信息:', res);
        store.dispatch('setUserInfo', res.data);
        localStorage.setItem('private', true);
        this.platform = res.data.platform;
        if (res.code == 200) {
          setTimeout(() => {
            this.ready = true;
          }, 0);
        }
      });
    },
    enterSystem() {
      if (this.platform == 'dating') {
        this.$router.push('/layout');
      } else if (this.platform == 'talkytimes') {
        this.$router.push('/talkytimes');
      }
    },
  },
};
</script>

<style scoped>
.private-page {
  margin: 0;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  font-family: 'Microsoft YaHei', sans-serif;
  position: relative;
  overflow: hidden;
}

.particles-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.welcome-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 2;
}

.welcome-content {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 20px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  min-width: 500px;
  width: 80%;
}

.logo-section {
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo {
  width: 80px;
  height: 80px;
  margin-bottom: 20px;
  border-radius: 50%;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.2s ease;
}

.logo:hover {
  transform: scale(1.05);
}

.logo:active {
  transform: scale(0.95);
}

.welcome-title {
  font-size: 28px;
  color: #333;
  margin: 0;
  font-weight: 600;
}

.info-section {
  margin-bottom: 40px;
}

.welcome-text {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
}

.loading-dots {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.loading-dots span {
  width: 8px;
  height: 8px;
  background: #667eea;
  border-radius: 50%;
  animation: loading 1.4s infinite ease-in-out;
}

.loading-dots span:nth-child(1) {
  animation-delay: -0.32s;
}

.loading-dots span:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes loading {
  0%,
  80%,
  100% {
    transform: scale(0);
    opacity: 0.5;
  }

  40% {
    transform: scale(1);
    opacity: 1;
  }
}

.action-section {
  margin-top: 30px;
}

.enter-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 15px 40px;
  border-radius: 50px;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 auto 15px;
}

.enter-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 30px rgba(102, 126, 234, 0.4);
}

.enter-btn:active {
  transform: translateY(0);
}

.enter-btn i {
  font-size: 16px;
}

.tip-text {
  font-size: 14px;
  color: #999;
  margin: 0;
}

.success-icon {
  margin: 20px 0;
}

.success-icon i {
  font-size: 48px;
  color: #67c23a;
  animation: successPulse 0.6s ease-in-out;
}

@keyframes successPulse {
  0% {
    transform: scale(0);
    opacity: 0;
  }

  50% {
    transform: scale(1.2);
    opacity: 0.8;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
